import { Injectable } from "@angular/core";
import { HttpClientService } from "../http-confing/http/http-client.service";

@Injectable({
  providedIn: "root"
})
export class ProductsService {
  constructor(private _Http: HttpClientService) {}
  get slider() {
    return this._Http.get("slider/get-all");
  }
  get categories() {
    return this._Http.get("category/get-all");
  }
  /**
   * get  all products
   * @param body  page : int
   */
  getProducts(body) {
    return this._Http.get("product/paginate", body);
  }

  /**
   * get products with catogery id
   * @param body category_id : INT , page : int
   */
  filterProducts(body) {
    return this._Http.get("product/get-by-category", body);
  }

  /**
   * get product all data
   * @param body  product_id : number
   */
  ProductProfile(body) {
    return this._Http.get("product/get", body);
  }

  /**
   * send interting form
   */
  interstingInProduct(body) {
    return this._Http.post(body, "product/add-interesting-user");
  }
  /**
   * search in products
   * @param body  keyword : ''
   */
  search(body) {
    return this._Http.get("product/search", body);
  }
}
